import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useState } from 'react';
import Modal from '../../../../../Modal';

const RoomImagesModal = ({ doShow, onClose, images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleCarouselChange = (index) => {
    setCurrentIndex(index);
  };

  if (!images || !images.length) return <></>;

  return (
    <Modal
      open={doShow}
      onClose={onClose}
      className="w-full md:w-1/2 lg:w-1/3 mx-auto overflow-hidden"
    >
      <div className="max-h-full p-2">
        <div className="text-theme font-bold sm:text-sm xl:text-lg mb-4">Room Images</div>
        <div>
          <Carousel autoPlay onChange={handleCarouselChange} className="text-center">
            {images.map((item) => (
              <div key={item.url} className="relative">
                <img src={item.url} alt={item.caption} />
                {images.length > 0 && images[currentIndex] && images[currentIndex].caption && (
                  <div className="absolute bottom-0 w-full text-center text-white text-sm mb-8">
                    <div className="bg-black bg-opacity-50 inline p-1 px-2">
                      {images[currentIndex].caption}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </Modal>
  );
};

RoomImagesModal.propTypes = {
  doShow: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.string),
};

RoomImagesModal.defaultProps = {
  doShow: false,
  images: [],
};

export default RoomImagesModal;
